/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReportTypeCode = 'BB' | 'RV' | 'VJE' | 'ERV' | 'ERVO';

export const ReportTypeCode = {
  Bb: 'BB' as ReportTypeCode,
  Rv: 'RV' as ReportTypeCode,
  Vje: 'VJE' as ReportTypeCode,
  Erv: 'ERV' as ReportTypeCode,
  Ervo: 'ERVO' as ReportTypeCode
};

